<template>
  <div>
    <div class="userinfo">
      <div class="leftcon">
        <div class="lefttl">
          <img
            :src="
              $store.state.WebLoginuser.logo || require('../image/user.png')
            "
            alt=""
            class="loadimg"
          />
          <div style="margin-top: 8px">
            {{ $store.state.WebLoginuser.name }}
          </div>
        </div>
        <div class="leftxia">
          <div
            id="selectF"
            @click="tabbarchange(0)"
            :class="tabbar == 0 ? 'tactive' : 'noactive'"
          >
            账号资料
          </div>
          <div
            id="selectF"
            @click="tabbarchange(1)"
            :class="tabbar == 1 ? 'tactive' : 'noactive'"
          >
            我的课程
          </div>
        </div>
      </div>
      <div class="rightcon" v-if="tabbar == '0'">
        <div class="righttl">账号资料</div>

        <el-form
          :model="formDatas"
          class="form3"
          :rules="rules"
          ref="ruleForm"
          label-width="80px"
          label-position="right"
          height="500"
        >
          <!-- 图片上传 -->
          <el-row>
            <el-col :span="12" class="specialSing">
              <el-form-item label="头像:">
                <div style="display: flex; width: 285px">
                  <label for="uploadFileInput" class="selectFile"
                    ><img
                      :src="picurl || require('../image/user.png')"
                      alt=""
                      class="loadimg"
                  /></label>
                  <input
                    type="file"
                    id="uploadFileInput"
                    required
                    style="display: none"
                    @change="selectPic"
                    ref="uploadFileInputREF"
                    accept="image/*"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
              ><el-form-item label="姓名:" prop="name">
                <el-input v-model="formDatas.name"> </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12"
              ><el-form-item label="角色:" prop="role">
                <div class="weirole">
                  {{ userRole(formDatas.role) }}
                </div>
              </el-form-item></el-col
            >
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="性别:" prop="sex">
                <el-radio-group v-model="formDatas.sex">
                  <el-radio label="男"></el-radio>
                  <el-radio label="女"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号:" prop="phone">
                <el-input
                  v-model.trim="formDatas.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="部门:" prop="company">
                <el-input
                  v-model="formDatas.company"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码:" prop="password">
                <el-input
                  v-model="formDatas.password"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="职位:" prop="major">
                <el-input
                  v-model="formDatas.major"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="elbt">
          <el-button @click="ensure" type="primary" :disabled="flag"
            >确认</el-button
          >
        </div>
      </div>
      <div class="rightcon" v-if="tabbar == '1'">
        <div class="righttl">我的课程</div>
        <!-- 有我的课程 -->
        <template v-if="totalSize != 0">
          <ul class="NewsList" v-loading="courseloading">
            <li v-for="item in mycourse" :key="item.id" class="coursecard">
              <div class="uniimg"><img :src="item.pic" /></div>
              <div class="icle2">
                <div class="arttitle2">{{ item.coursename }}</div>

                <div class="huisec">课程科目：{{ item.course }}</div>
                <div class="huisec">
                  课程分类：{{ item.type }}
                  <!-- {{ uppercase(videourlType(item.videourl)) }} -->
                </div>
                <p class="learntime">已学{{ item.progress || 0 }}%</p>
              </div>
              <div class="continuelearn" @click="continuelearn(item)">
                继续学习
              </div>
            </li>
          </ul>
          <el-pagination
            background
            layout="prev, pager, next"
            next-text="下一页"
            prev-text="上一页"
            :total="totalSize"
            :current-page="current_page"
            @current-change="current_change"
            @next-click="next_click"
            @prev-click="prev_click"
            :page-size="pageSize"
          >
          </el-pagination>
        </template>
        <!-- 没有我的课程 -->
        <template v-if="totalSize == 0">
          <el-empty :image-size="200"></el-empty>
        </template>
        <FilePreview
          :havepro="havepro"
          :showFilePreview="showFilePreview"
          :currentFile="currentFile"
          @close="close"
          v-if="showFilePreview"
          :layer="layer"
        ></FilePreview>
      </div>
    </div>
  </div>
</template>
<script>
import FilePreview from "../components/FilePreview.vue";

export default {
  name: "Userinfo",
  components: {
    FilePreview,
  },
  data() {
    return {
      havepro: 0,
      selectId: 0,
      layer: "usercourseinfo",
      currentFile: {},
      showFilePreview: false,

      current_page: 1,
      totalSize: 0,
      pageSize: 3,
      mycourse: "",
      flag: false,
      tabbar: "",
      userupload: null, //课程封面照片
      picurl: "", //课程封面照片
      formDatas: {
        name: "",
        sex: "",
        role: "",
        password: "",
        major: "",
        phone: "",
        company: "",
      },
      rules: {
        major: [{ required: true, message: "请输入", trigger: "blur" }],
        company: [{ required: true, message: "请输入", trigger: "blur" }],
        password: [
          {
            required: true,
            trigger: "change",
            message: "请至少输入6位的密码",
            min: 6,
          },
          {
            pattern: /^[0-9A-Za-z]{6,18}$/,
            message: "请输入数字或字母",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [
          {
            required: true,
            message: "请输入",
            trigger: "blur",
          },
          {
            message: "请输入正确手机号",
            trigger: "blur",
            pattern: /^1[3-9](\d{9})$/,
          },
        ],
      },
      courseloading: true,
    };
  },

  created() {
    this.tabbar = this.$store.state.userinfo_tab;
  },
  updated() {
    if (this.$store.state.WebLoginuser == "") {
      this.$router.push("/homePage");
    }
    this.tabbar = this.$store.state.userinfo_tab;
  },

  computed: {
    data() {
      return this.$store.state.userinfo_tab;
    },
  },

  watch: {
    // 监听 store变量 ，以此触发tabbarchange()事件
    data: {
      handler(n, m) {
        this.tabbarchange(n);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    //切换事件
    tabbarchange(i) {
      this.$store.state.userinfo_tab = i;
      this.tabbar = this.$store.state.userinfo_tab;
      if (i == "1") {
        this.requestent();
      }
      if (i == "0") {
        this.EditOwnInfo();
      }
    },

    // 选择照片
    selectPic() {
      this.$nextTick(() => {
        var uploadFile1 = this.$refs.uploadFileInputREF;
        var file = uploadFile1.files;
        var fr = new FileReader();
        if (file.length > 0) {
          fr.readAsDataURL(file[0]);
          if (file[0].name.indexOf(",") != -1) {
            alert("文件名中包含逗号（,）禁止上传，请重命名后上传。");
            return;
          }
          if (!file[0].type.includes("image/")) {
            alert("请上传图片文件！");
            return;
          }

          fr.onload = (e) => {
            this.userupload = file[0];
            this.picurl = e.target.result; //只是先预览图片
          };
        }
      });
    },
    // 修改资料
    ensure() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let copydata2 = Object.assign({}, this.formDatas);
          if (this.userupload != null) {
            copydata2.logo = this.userupload.name;
          }
          this.$axios({
            methods: "get",
            url:
              "Data?uid=39&layer=userinfo&operation=query&queryfields=phone&queryvalues=" +
              copydata2.phone,
          }).then((res) => {
            if (
              res.data.size > 0 &&
              copydata2.phone != this.$store.state.WebLoginuser.phone
            ) {
              this.$message({
                type: "warning",
                message: "手机号重复",
              });
            } else {
              copydata2 = encodeURIComponent(JSON.stringify(copydata2));
              var fd2 = new FormData();
              fd2.append("jsondata", copydata2);
              if (this.userupload != null) {
                fd2.append(this.userupload.name, this.userupload);
              }

              this.$axios({
                method: "post",
                url: `Data?uid=39&layer=userinfo&operation=edit&queryfields=id&queryvalues=${this.$store.state.WebLoginuser.id}`,
                data: fd2,
              }).then((res) => {
                this.flag = true;
                if (res.data.state) {
                  this.$message({
                    type: "success",
                    message: "修改成功",
                  });
                  this.EditOwnInfo();
                } else {
                  this.$message({
                    type: "error",
                    message: "修改失败",
                  });
                }
                setTimeout(() => {
                  this.flag = false;
                }, 1000);
              });
            }
          });
        } else {
          this.$message.error("表单验证未通过,请您检查输入的内容");
          return false;
        }
      });
    },
    EditOwnInfo() {
      this.$axios({
        methods: "get",
        url:
          "Data?uid=39&layer=userinfo&operation=query&queryfields=id&queryvalues=" +
          this.$store.state.WebLoginuser.id,
      }).then((res) => {
        if (res.data.state) {
          this.$store.state.WebLoginuser = res.data.data[0];
          this.picurl = this.$store.state.WebLoginuser.logo;
          this.formDatas = Object.assign({}, this.$store.state.WebLoginuser);
          this.formDatas.logo = this.$store.state.WebLoginuser.logo;
        }
      });
    },
    // 角色识别
    userRole(role) {
      if (role == "admin") {
        return "管理员";
      } else if (role == "superadmin") {
        return "超级管理员";
      } else if (role == "normal") {
        return "普通用户";
      } else {
        return role;
      }
    },
    requestent() {
      this.courseloading = true;
      const start = (this.current_page - 1) * this.pageSize + 1;
      this.$axios({
        method: "get",
        url:
          "Data?uid=39&layer=usercourseinfo&operation=query&queryfields=userid&queryvalues=" +
          this.$store.state.WebLoginuser.id +
          "&start=" +
          start +
          "&count=" +
          this.pageSize +
          "&orderfields=id%2520desc",
      }).then((res) => {
        if (res.data.size > 0) {
          this.totalSize = res.data.size;
          this.mycourse = res.data.data;
          this.courseloading = false;
        } else {
          this.current_page = 1;
        }
      });
    },
    // 获取当前页码
    current_change(val) {
      this.current_page = val;
      this.requestent();
    },
    //下一页
    next_click(n) {
      this.current_page = n;
      this.requestent();
    },
    //上一页
    prev_click(p) {
      this.current_page = p;
      this.requestent();
    },
    videourlType(htmlHref) {
      if (htmlHref) {
        let name = htmlHref;
        return name.substring(name.lastIndexOf(".") + 1, name.length);
      }
    },
    uppercase(t) {
      if (t) {
        return t.toUpperCase();
      }
    },
    close(data) {
      var objd = {};
      let name = this.currentFile.fileUrl;
      let videotype = name.substring(name.lastIndexOf(".") + 1, name.length);
      // 视频有进度，其他点开再关闭就是100%
      if (videotype != "mp4") {
        objd.progress = "100";
      } else {
        if (data != "") {
          objd.progress = data.toString();
        } else {
          objd.progress = "0";
        }
      }
      this.showFilePreview = false;
      var fd = new FormData();
      let copyfd = encodeURIComponent(JSON.stringify(objd));
      fd.append("jsondata", copyfd);
      this.$axios({
        method: "post",
        url:
          "Data?uid=39&layer=usercourseinfo&operation=edit&queryfields=id&queryvalues=" +
          this.selectId,
        data: fd,
      }).then((res) => {
        if (res.data.state) {
          this.requestent();
        }
      });
    },
    continuelearn(item) {
      if (item) {
        this.$axios({
          method: "get",
          url:
            "Data?uid=39&layer=courselist&operation=query&queryfields=id&queryvalues=" +
            item.courseid +
            "&outfields=videourl",
        }).then((res) => {
          this.currentFile.fileUrl = res.data.data[0].videourl;
          this.showFilePreview = true;
          this.selectId = item.id;
          this.havepro = parseFloat(item.progress);
        });
      }
    },
  },
};
</script>

<style scoped>
.weirole {
  width: 300px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.icle2 {
  width: 560px;
}
.continuelearn {
  box-sizing: border-box;
  width: 90px;
  height: 36px;
  background: #047ac6;
  border-radius: 4px;
  color: #fff;
  text-align: center;
  line-height: 36px;
  margin-left: 10px;
  margin-top: 70px;
  cursor: pointer;
}
.learntime {
  font-size: 14px;
  color: #047ac6;
}
.NewsList {
  /* width: 1200px; */
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.huisec {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-bottom: 10px;
}
.arttitle2 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 5px 0 20px 0;
}
.NewsList .uniimg {
  height: 122px;
  border: 1px solid #d2d2d2;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  margin-right: 26px;
}
.uniimg img {
  width: 200px;
  height: 122px;
  object-fit: cover;
}
.NewsList li {
  box-sizing: border-box;
  position: relative;
  padding: 30px 0;
  /* height: 181px; */
  display: flex;
  box-sizing: border-box;
  background: #fff;
  text-align: left;
  border-bottom: 1px dashed #d6d6d6;
}

.elbt {
  width: 100%;
  margin: 20px auto;
  text-align: center;
}
.tactive {
  color: #047ac6;
  position: relative;
}
.tactive::before {
  background: #047ac6;
  display: block;
  content: "";
  width: 4px;
  height: 24px;
  position: absolute;
  top: 15px;
  left: 0px;
  clear: both;
}
.noactive {
  color: #333333;
}
#selectF {
  cursor: pointer;
  box-sizing: border-box;
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 16px;
}
/* 悬浮样式 */
/* #selectF:hover{
  background:#d2d2d2 ;
} */
.form3 {
  margin-top: 40px;
}
.loadimg {
  border: 0.6px solid #d6d6d6;
}
.selectFile,
.loadimg {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
}

.appendbox {
  display: flex;
  align-items: center;
}
.baseview {
  width: 100%;
  background: #eee;
}
.userinfo {
  padding-top: 30px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  background: #eee;
}
.lefttl {
  box-sizing: border-box;
  height: 193px;
  padding-top: 40px;
  text-align: center;
  width: 230px;
  border-bottom: 1px solid #d6d6d6;
}
.leftxia {
  height: 140px;
  box-sizing: border-box;
  padding-top: 10px;
}
.leftcon {
  width: 230px;
  height: 334px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}
.rightcon {
  width: 951px;
  margin-left: 20px;
  background: #ffffff;
  padding-bottom: 40px;
}
.righttl {
  box-sizing: border-box;
  padding-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #d6d6d6;
}
</style>